import React from 'react';
import { connect } from "react-redux";

import configData from "../../../config/config.json"
import axios from "axios";

import { Modal, Container, Col, Row, Button } from 'react-bootstrap'
import Paginator from '../page/Paginator'
import { getPaginatorHelper } from '../page/PaginatorHelper'
import Loading from '../modal/Loading';
import translations from "../../../config/translation/alert_entry_translations.json";

import { LOADING_STATUES } from "../../constants/constants";

export const EmailAddressSelectionListComponentName = "EmailAddressSelectionListComponentName";

const mapStateToProps = state => {
    return {
        language: state.languageReducer ? state.languageReducer : 'ENGLISH',
        paginationPage: state.emailAddressSelectionListPaginationReducer 
    };
}

class EmailAddressSelectionList extends React.Component {
    state = {
        filteredList: [],
        loadingStatus: ''
    }

    handleFilter = () => {
        if (this.showLoading() !== true) {
            return;
        }

        let filters = {  userId: this.props.userId };
        axios.post(configData.LANDNOTIFICATION_SERVER_URL + "helperdata/useremailaddressescodedescription", filters, { withCredentials: true })
            .then((response) => {
                this.setState({ filteredList: response.data.content.codeDescriptionResultList, loadingStatus: '' })
            }, (error) => {
                this.setState({  filteredList:[], loadingStatus: '' });
            });
    }

    handleCloseClick = () => {
        this.props.onHide();
    }

    handleRowClick = (event) => {
        this.props.onHide(event.target.closest("tr").id, event.target.closest("tr").getAttribute("name"));
    }

    handleKeyDown = (event) => {
      
        // 13 is Enter. 
        if (event.type === 'keydown' && event.keyCode === 13) {
          this.props.onHide(event.target.closest("tr").id, event.target.closest("tr").getAttribute("name"));
        }
    }
    
    showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

    componentDidMount() {
		this.handleFilter();
	}

    render() {
        let filteredList = this.state.filteredList;
        if (!filteredList) {
            return <></>
        }

        const numberOfVisibleRecords = 10;
        let numberOfPages = Math.ceil(filteredList.length / numberOfVisibleRecords);
        let paginationHelper = getPaginatorHelper(this.props.paginationPage, filteredList, numberOfVisibleRecords);

        return (
            <>
            <Modal show={this.props.showModal}>
                <Modal.Header style={{ borderBottom: '2px solid #145A7B' }} >
                    <Modal.Title id="contained-modal-title-vcenter" style={{color: '#145A7B'}}>
                         {translations[this.props.language].click_email}:
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="show-grid">
                    <Col style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <Container fluid="true" style={{ paddingLeft: 0, paddingRight: 0, marginRight: 2, marginTop: 2, border: '3px solid darkGray', borderRadius: '5px' }}>
                            <table className="table table-striped table-hover">
                                <thead >
                                    <tr>
                                        <th scope="col">{translations[this.props.language].my_email_address_list}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        paginationHelper.currentPageRecordList.map((record) => {
                                            return (
                                                <tr style={{ cursor: "pointer" }} id={record.code} name={record.description} onClick={this.handleRowClick} onKeyDown={this.handleKeyDown} >
                                                    <td tabIndex={0}>{record.description}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </Container>
                        <Container fluid="true" style={{ paddingLeft: 0, paddingRight: 0, marginRight: 2, marginTop: 2 }}>
                            <Row>
                                <Col><Paginator style={{ justifyContent: 'center' }} componentName={EmailAddressSelectionListComponentName} numberOfVisibleRecords={numberOfVisibleRecords} numberOfPages={numberOfPages} ></Paginator></Col>
                            </Row>
                            <Row>
                                <Col>{translations[this.props.language].displaying_results}: {paginationHelper.currentPageStartingRecordNumber}-{paginationHelper.currentPageEndingRecordNumber} of {filteredList.length}</Col>
                            </Row>

                        </Container>
                    </Col>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleCloseClick}>{translations[this.props.language].close}</Button>
                </Modal.Footer>
            </Modal>
             <Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
             </>
        )
    }
}

export default connect(mapStateToProps)(EmailAddressSelectionList);
